/**
 * Omora Custom: Aura Reveal Animation
 * Staggered reveal for "Dein Raum. / Deine Aura. / Dein Schutz." headings.
 * Requires omora-aura-reveal.css for keyframe definitions.
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var mainSection = document.querySelector('.section-wrapper .page-width-content');
  if (!mainSection) return;

  var headings = mainSection.querySelectorAll('.section-content-wrapper > .text-block.h2');
  if (headings.length < 2) return;

  headings.forEach(function (heading, i) {
    heading.classList.add('aura-reveal');
    heading.setAttribute('data-aura-index', String(i));
  });

  var auraObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          headings.forEach(function (h) {
            h.classList.add('aura-reveal--visible');
          });
          auraObserver.disconnect();
        }
      });
    },
    { threshold: 0.3 }
  );

  auraObserver.observe(headings[0]);
})();
